import { brandEntityId } from "./brand-entity-id";
import { brandLogoDataHeight } from "./brand-logo-data-height";
import { brandLogoDataUrl } from "./brand-logo-data-url";
import { brandLogoDataWidth } from "./brand-logo-data-width";
import { brandLogoEntityId } from "./brand-logo-entity-id";
import { brandLogoIsDefault } from "./brand-logo-is-default";
import { brandLogoIsInUse } from "./brand-logo-is-in-use";
import { brandLogoSid } from "./brand-logo-sid";

export const brandLogoEntityRaw = {
  type: "object",
  required: [
    "id",
    "sid",
    "dataUrl",
    "width",
    "height",
    "isDefault",
    "isInUse",
    "brandId"
  ],
  properties: {
    id: brandLogoEntityId,
    sid: brandLogoSid,
    dataUrl: brandLogoDataUrl,
    width: brandLogoDataWidth,
    height: brandLogoDataHeight,
    isDefault: brandLogoIsDefault,
    isInUse: brandLogoIsInUse,
    brandId: brandEntityId
  },
  additionalProperties: false
};
